"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_redux_1 = require("react-redux");
const roomViewStore_1 = require("@/room/room_view/roomViewStore");
const react_i18next_1 = require("react-i18next");
const components_1 = require("@/common/components");
const string_utils_1 = require("@/common/string_utils");
function default_1() {
    const productData = (0, react_redux_1.useSelector)((state) => state.productData);
    const dispatch = (0, react_redux_1.useDispatch)();
    const addItem = (productIndex) => {
        dispatch((0, roomViewStore_1.addToCart)(productIndex));
    };
    const salesClosed = (0, react_redux_1.useSelector)((state) => state.roomData.salesClosed);
    const { t } = (0, react_i18next_1.useTranslation)();
    const getOptionPrefix = ({ isNotAvailable, remainStock, }) => {
        if (isNotAvailable)
            return `[${t(salesClosed ? '마감' : '품절')}] `;
        else if (remainStock < 10)
            return `[${t('remainStock개 남음', { remainStock })}] `;
        else
            return '';
    };
    return ((0, jsx_runtime_1.jsxs)(components_1.NativeSelect, Object.assign({ value: '', onChange: e => addItem(Number(e.target.value)), sx: {
            height: '40px',
            p: '0 16px',
            border: '1px solid rgba(0, 0, 0, 0.15) !important',
            borderRadius: '2px',
            mb: '6px',
            fontSize: '15px',
            '.MuiNativeSelect-icon': { right: '16px', width: '24px', height: '24px' },
        } }, { children: [(0, jsx_runtime_1.jsx)("option", Object.assign({ value: "" }, { children: t('메뉴 담기') })), productData.map((product, idx) => {
                const { id, isSoldOut, remain_stock: remainStock, name, price } = product;
                const isNotAvailable = isSoldOut || salesClosed;
                const optionPrefix = getOptionPrefix({ isNotAvailable, remainStock });
                return ((0, jsx_runtime_1.jsx)("option", Object.assign({ value: idx, disabled: isNotAvailable }, { children: optionPrefix + `${name} (${(0, string_utils_1.money)(price)}${t('원')})` }), `product_select_option_${id}_${idx}`));
            })] })));
}
exports.default = default_1;
